export const useStyles = theme => ({
  activeChapter: {
    color: '#7AB800',
    font: 'normal normal medium 18px/24px Maax-Medium',
  },
});
